import HighlightImage from "./highlight";
export default HighlightImage;